import { createContext, useContext, type ReactNode } from "react";
import type { Me } from "../api/types";

const Ctx = createContext<Me | null>(null);

export function AuthProvider({ me, children }: { me: Me; children: ReactNode }) {
  return <Ctx.Provider value={me}>{children}</Ctx.Provider>;
}

export function useAuth(): Me & { can: (perm: string) => boolean } {
  const me = useContext(Ctx);
  if (!me) throw new Error("useAuth hors AuthProvider");
  return { ...me, can: (p: string) => me.permissions.includes(p) };
}

export const ROLE_LABEL: Record<string, string> = {
  SUPER_ADMIN: "Super admin", ADMIN: "Administrateur", MANAGER: "Manager", OPERATOR: "Opérateur", CLIENT: "Client",
};
